module.exports = __webpack_public_path__ + "media/images/logo-e26083688583a9ed5ebb945adfdea9b4.gif";